import { render } from "./PaysList.vue?vue&type=template&id=50e92b76"
import script from "./PaysList.vue?vue&type=script&lang=js"
export * from "./PaysList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__